import { zodResolver } from '@hookform/resolvers/zod';
import { forgotPasswordSchema } from '@willnq/shared/validation/authSchemas';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import type { z } from 'zod';

import { authService } from '@/services/authService';
import { parseRestError } from '@/utils/errorUtils';

type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;

/** Drives `ForgotPasswordForm`. The backend always returns success (anti-enumeration) so the
 * neutral confirmation renders regardless of whether the account exists. */
export function useForgotPassword() {
  const [serverError, setServerError] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);

  const form = useForm<ForgotPasswordFormValues>({
    resolver: zodResolver(forgotPasswordSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: { email: '' },
  });

  const onSubmit = form.handleSubmit(async (values) => {
    setServerError(null);
    try {
      await authService.forgotPassword(values.email);
      setSubmitted(true);
    } catch (error) {
      const { message } = parseRestError(error);
      setServerError(message);
    }
  });

  return { form, onSubmit, serverError, submitted };
}
